import { httpInterceptorProviders } from './shared/interceptors/interceptorProviders';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './base-components/app-component/app.component';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, APP_INITIALIZER, LOCALE_ID, NO_ERRORS_SCHEMA } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppConfigService } from './shared/services/AppConfigService';
import { DatePipe, registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar-SA';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { PortalHomeComponent } from './base-components/home/portal-home/portal-home.component';
import { UserSessionService } from './shared/services/user-session-service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CacheService } from './shared/services/cashe-service';
// import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';


registerLocaleData(localeAr);


const isIE =
  window.navigator.userAgent.indexOf('MSIE') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

const appInitializerFn = (appConfig: AppConfigService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};

@NgModule({
  declarations: [
    AppComponent,
    PortalHomeComponent    
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    CacheService,
    JwtHelperService,
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService],
    },
    TranslateService,
    UserSessionService,
    DatePipe,
    httpInterceptorProviders,
  ],schemas:[
    NO_ERRORS_SCHEMA
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    NgbModule,
    NgxSpinnerModule,
    // BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      defaultLanguage: localStorage.getItem('lang') == 'en' ? 'en' : 'ar',
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    HttpClientModule,

  ],
})
export class AppModule {}

export function httpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}
